"use client";

import * as React from "react";
import { usePathname } from "next/navigation";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import SuperTokensReact, { SuperTokensWrapper } from "supertokens-auth-react";
import { frontendConfig } from "../config/auth/supertokens/frontend/frontendConfigUtils";
import { Toaster } from "@workspace/ui/components/sonner";
import { TooltipProvider } from "@workspace/ui/components/tooltip";
import { UploadLeaveGuard } from "@/components/upload-leave-guard";
import { AnalyticsProvider } from "@/components/analytics/analytics-provider";

let hasInitialisedSuperTokens = false;

function ensureSuperTokensInitialized() {
  if (typeof window === "undefined" || hasInitialisedSuperTokens) {
    return;
  }

  SuperTokensReact.init(frontendConfig());
  hasInitialisedSuperTokens = true;
}

function AuthProvider({ children }: { children: React.ReactNode }) {
  ensureSuperTokensInitialized();

  return <SuperTokensWrapper>{children}</SuperTokensWrapper>;
}

function isPublicSharePath(pathname: string | null) {
  return pathname === "/share" || pathname?.startsWith("/share/");
}

export function Providers({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const content = isPublicSharePath(pathname) ? (
    children
  ) : (
    <AuthProvider>{children}</AuthProvider>
  );

  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      enableColorScheme
    >
      <AnalyticsProvider>
        <TooltipProvider>
          {content}
          <UploadLeaveGuard />
          <Toaster richColors position="bottom-right" />
        </TooltipProvider>
      </AnalyticsProvider>
    </NextThemesProvider>
  );
}
